import React, { useState } from 'react'
import LoginScreen from './components/LoginScreen'
import MainApp from './components/MainApp'

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [currentTIN, setCurrentTIN] = useState('')

  const handleLogin = (tin) => {
    setCurrentTIN(tin)
    setIsAuthenticated(true)
  }

  const handleLogout = () => {
    setIsAuthenticated(false)
    setCurrentTIN('')
  }

  return (
    <>
      {!isAuthenticated ? (
        <LoginScreen onLogin={handleLogin} />
      ) : (
        <MainApp currentTIN={currentTIN} onLogout={handleLogout} />
      )}
    </>
  )
}

export default App
